import React from "react";
import S from "./BreadCrumbs.styled";
import { Breadcrumb } from "gatsby-plugin-breadcrumb";
import "gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css";
import { getPageTitles } from "@/src/helpers/getPageTitles";

type Props = {
  color: string;
  breadcrumb?: BreadCrumbProps;
  title: string;
};

export type BreadCrumbProps = {
  crumbs: {
    crumbLabel: string;
    pathname: string;
  }[];
  location: string;
};

const BreadCrumbs: React.FC<Props> = ({ breadcrumb, color, title }) => {
  const modifiedCrumbs = breadcrumb && getPageTitles(breadcrumb.crumbs);

  return (
    <S.Wrapper $color={color}>
      <Breadcrumb
        crumbs={modifiedCrumbs}
        crumbSeparator="/"
        crumbLabel={title}
      />
    </S.Wrapper>
  );
};

export default BreadCrumbs;
